<template>
  <div class="cx_tab">
    <div class="cx_tab_header">
      <div class="cx_tab_header_left" ref="tab_outer">
    <b-nav tabs ref="tab">

      <template v-for="(caption, index) in tabs">
        <!-- <b-nav-item
          v-if="visibles[index]"
          :key="index"
          :active="index == currentId"
          @click="onClick(index)"
        >{{ $translate(caption) }}<i v-if="invalids[index]" class="material-icons small valign">error</i></b-nav-item> -->
        <li class="nav-item" :key="index" v-if="visibles[index]">
          <span  class="nav-link" :class="{active: index == currentId}" @click="onClick(index)">{{ $translate(caption) }}<i v-if="tooltips[index] && index == currentId" class="material-icons small valign help" ref="tooltip_target">help_outline</i><i v-if="invalids[index]" class="material-icons small valign">error</i></span>
        </li>
      </template>
    </b-nav>
    </div>
    <!-- spモードでは非表示 -->
    <div class="cx_tab_header_right" :style="{width: scrollWidth + 'px'}" v-if="$api.spMode == false">
    <Button class="cx_tab_button left" @mousedown="scrollStart('left')" @mouseup="scrollEnd" icon="navigate_before" v-if="tabIsOverflown"/>
    <Button class="cx_tab_button right" @mousedown="scrollStart('right')" @mouseup="scrollEnd" icon="navigate_next" v-if="tabIsOverflown"/>    
    </div>
    </div>
    <div class="cx_tabcontent">
      <template v-for="(caption, index) in tabs">       
        <!-- コントロールバリデーションの関係で非表示にしておく必要がある～その結果、非表示部分のコントロールのリサイズイベントを処理できない -->
        <!-- <div class="cx_tabinner" :style="{'display': currentId==index ? 'block':'none'}" :key="index" :ref="'tabEL' + index" :class="{cx_tabinner_0: index==0 && svg}">         -->
        <div class="cx_tabinner" :style="{'display': currentId==index ? 'block':'none'}" :key="index" :ref="'tabEL' + index">        
        <!-- <div class="cx_tabinner" :key="index" v-if="currentId==index"> -->
          <slot :name="'tab' + index"></slot>
          <!-- <SvgIcon :name="svg" v-if="svg && index==0" :width="56" :height="56" class="cx_tab_svg"/> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as Common from "@/agiles/common";
import ResizeObserver from "resize-observer-polyfill";

@Component
export default class Tab extends Vue {
  @Prop({ default: () => new Array() }) public tabs?: Array<string>;
  @Prop({ default: () => new Array() }) public visibles?: Array<boolean>;
  @Prop({ default: () => new Array() }) public invalids?: Array<boolean>;
  @Prop({ default: () => new Array() }) public tooltips?: Array<string>;  
  @Prop({default: 200}) public scrollWidth:number;
  @Prop({ default: null }) public svg: string;  //基本情報のアイコン表示用

  public currentId: number = 0;
    
  public get tabElements() :HTMLElement[] {
    return Object.keys(this.$refs).filter(key => key.startsWith('tabEL')).map(key=>this.$refs[key] as HTMLElement).flat() ;   
  }
  @Watch("visibles")
  public onVisibleChanged(newValue:any, oldValue:any) {
    //未設定の配列が再度pushされる場合がある
    if(this.visibles.length ==0) this.tabs.forEach(text => this.visibles.push(true));
    //表示タブを決定する
    if (this.visibles[this.currentId] == false || this.currentId == -1) {
      let temp = -1;
      this.visibles.forEach((value, index) => {
        if (value && temp == -1) temp = index;
      });
      this.currentId = temp;
    }
  }

  public created() {
    // if (this.tabs && this.visibles==null){
    //   // this.visibles = new Array();
    //   this.tabs.forEach(text=> this.visibles.push(true));
    // }
    if(this.visibles.length ==0) this.tabs.forEach(text => this.visibles.push(true));
    if(this.invalids.length ==0) this.tabs.forEach(text => this.invalids.push(false));    
    if(this.tooltips.length ==0) this.tabs.forEach(text => this.tooltips.push(null));
  }
  public mounted(){
    let observer = new ResizeObserver(this.onSizeChanged);    
    observer.observe(this.$refs.tab as HTMLElement);        
    this.onClick(0);
  }

  public tabIsOverflown:boolean = false;
  public onSizeChanged(){
    var target = this.$refs.tab as HTMLElement;  
    if (target && target.scrollWidth > target.clientWidth) this.tabIsOverflown = true;
    else this.tabIsOverflown = false;
  }
   intervalId:any = null;
   public scrollStart(direction:string){
     if (direction == 'left') this.intervalId = setInterval(this.scrollLeft,100);
     else if (direction == 'right') this.intervalId = setInterval(this.scrollRight,100);
   }
   public scrollEnd(){
     if (this.intervalId) clearInterval(this.intervalId);
   }
   public scrollLeft(){
    var target = this.$refs.tab_outer as HTMLElement;
    target.scrollTo(target.scrollLeft-20,0);
  }
  public scrollRight(){
    var target = this.$refs.tab_outer as HTMLElement;    
    target.scrollTo(target.scrollLeft+20,0);
  }
  public onClick(index: number) {
    this.currentId = index;
    this.$nextTick(()=>{
      if(this.tooltips[index]) this.$api.tooltip.mount(this, (this.$refs.tooltip_target as Element[])[0],this.tooltips[index]);
    });
  }
}
</script>
<style lang="scss">
@import "@/agiles/components/style.scss";
.cx_tab {
  @extend .cx_vertical_fill;
  width: 100%;
  height: 100%;
  color:#2C304F;
  //padding-top:10px;
  ul {
    padding-left: 30px;
  }
  .cx_tab_header{
    display: flex;

    // タブエリア
    .cx_tab_header_left{
      display: block;
      flex:1;
      overflow-x: hidden;

      .cx_spmode & {
        overflow-x: auto;

        ul {
          justify-content: unset;
        }
      }
      // タブの折り返しを禁止
      ul {      
        flex-wrap: unset;
        li {
          flex-shrink: 0;
        }
      }
    }
    //タブスクロールエリア
    .cx_tab_header_right{
      // width: 200px;
      display: flex;
      align-items: flex-end;
      border-bottom: 1px solid #dee2e6;      
      padding-left: 5px;
    }
    .cx_tab_button{
      height: 20px;
      width: 20px;
      padding:0 0 0 0;

      &.left{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;    
        border-top-right-radius: 0;
      }
      &.right{
        border-bottom-left-radius: 0;        
        border-bottom-right-radius: 0;        
        border-top-left-radius: 0;
      }

      i {
        vertical-align: unset;
      }
    }
  }

  .cx_tabcontent {
    @extend .cx_vertical_scroll;
    overflow-x: hidden;
    width: 100%;
    padding: 20px 0px 5px 0px;     
    // background-color: #f9f9f9;
    background-color: #F7F7F7;

    .cx_tabinner{
      display:block;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;       
    }
  }
  .nav-tabs {
  }
  .nav-link {
    padding-top: 5px;
    padding-bottom: 3px;
    font-size: 15px;
    background: linear-gradient(to bottom, #f9f9f9 0, #e0e0e0 100%);
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #e0e0e0;
    // color:#444;
    color:#2C304F;
    margin-left: 5px;

    &:hover {
      background: linear-gradient(to bottom, #f6f6f6 0, #d4d4d4 100%);
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;
      border-right: 1px solid #bbb;
      border-bottom: 1px solid #d4d4d4;
      cursor: pointer;
    }
    &.active {
      background: none;
      background-color: #f9f9f9;
      border-bottom: 1px solid #f9f9f9;
      border-top: 2px solid #f7a203;
      white-space: nowrap;    
      cursor:default;  
    }

    i.small {
      margin-left:2px;
      margin-bottom:3px;
      margin-right:0px;
      font-size: 15px;
      color:red;      
      
      &.help {
        margin-left:1px;        
        color:gray;      
        &:hover{
          color:#007bff;                
          cursor:pointer;
        }
      }
    }
  }
}
</style>